import { getDeviceId, getNonce, generateCodeChallenge } from "./utils";
import axios from "axios";
export const authorize = async (
  redirect_uri,
  client_id,
  ui_locales,
  idp_id,
  login_hint,
  prompt,
  state
) => {
  const searchParams = new URLSearchParams({
    response_type: RESPONSE_TYPE[client_id] || DEFAULT_RESPONSE_TYPE,
    client_id,
    redirect_uri: window.location.href.split("?")[0],
    state: btoa(
      JSON.stringify({
        referrer: redirect_uri,
        client_id,
        state,
        prompt,
      })
    ),
    scope: SCOPE[client_id],
    device_id: getDeviceId(),
    nonce: NONCE[client_id] || getNonce(32),
    ui_locales,
  });
  if (idp_id) {
    searchParams.append("idp_id", idp_id);
  }
  if (login_hint) {
    searchParams.append("login_hint", login_hint);
  }
  if (prompt) {
    searchParams.append("prompt", prompt);
  }
  if (CODE_CHALLENGE_METHOD[client_id]) {
    searchParams.append(
      "code_challenge_method",
      CODE_CHALLENGE_METHOD[client_id]
    );
    searchParams.append("code_challenge", await generateCodeChallenge());
  }
  window.location.href = `${
    AUTHORIZE_URL[client_id] || STARFLEET_URL
  }?${searchParams.toString()}`;
};

export const getToken = (code) => {
  return axios.post(
    TOKEN_URL,
    new URLSearchParams({
      code,
      grant_type: GRANT_TYPE,
      code_verifier: sessionStorage.getItem("CV"),
      redirect_uri: window.location.href.split("?")[0],
    })
  );
};
